import { axios } from '@/di-container/axios';
import { GeoLocationRegistration, GeoLocationRequest } from '@/types';
import { HttpClient } from '@remodeling/base';
import { PostGeoLocationGateway } from '@remodeling/shop';
import { merge } from 'lodash';

export const shopGeoLocationGateway = () => {
  return {
    postGeoLocation: new ClientPostGeoLocationGateway(axios),
  };
};

class ClientPostGeoLocationGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GeoLocationRegistration) {
    const mergeReg = merge(req, {
      deptCode: 'MALL',
      deviceCode: 'WEB',
    }) as GeoLocationRequest;

    const apiResponse = await new PostGeoLocationGateway(axios).exec(mergeReg);
    return apiResponse;
  }
}
